import { createRouter, createWebHashHistory } from "vue-router";
import { GetUrlParam, SaasApi } from "qk-lib-v3";

const routeArray = [
    //首页
    { path: "/", name: "登录页", component: () => import("../views/Login/index2.vue") },
    { path: "/LoginSafe", name: "安全登录页", component: () => import("../views/LoginSafe/index.vue") },
    { path: "/MainIndex", name: "首页", component: () => import("../views/MainIndex/index.vue") },
    { path: "/MultipleMain", name: "多商户版首页", component: () => import("../views/MultipleMain/index.vue") },
    { path: "/SmallAppQrCode", name: "小程序", component: () => import("../views/SmallAppQrCode/index.vue") },
    { path: "/SelectOrganize", name: "选择商户", component: () => import("../views/SelectOrganize/index.vue") },
    { path: "/Organize", name: "商户管理", component: () => import("../views/Organize/index.vue") },
    { path: "/OrganConfig", name: "商户配置", component: () => import("../views/OrganConfig/index.vue") },
    { path: "/AuditTable", name: "数据审核", component: () => import("../views/AuditTable/index.vue") },
    { path: "/ManagerRelOrgan", name: "商户管理员", component: () => import("../views/ManagerRelOrgan/index.vue") },

    { path: "/PrintModuleType", name: "打印模板类型", component: () => import("../views/PrintModuleType/index.vue") },
    { path: "/PrintModule", name: "打印模板", component: () => import("../views/PrintModule/index.vue") },
    { path: "/ManagerInfo", name: "注册用户关联", component: () => import("../views/ManagerInfo/index.vue") },

    { path: "/TicketStore", name: "票据库存", component: () => import("../views/TickStore/index.vue") },
    { path: "/TicketOut", name: "票据出库", component: () => import("../views/TickOut/index.vue") },
    { path: "/OrganProfitSettlement", name: "商户利润结算", component: () => import("../views/OrganProfitSettlement/index.vue") },
    { path: "/SettlementUserInfo", name: "结算账户信息", component: () => import("../views/SettlementUserInfo/index.vue") },
    { path: "/OrganSettlement", name: "商户结算信息", component: () => import("../views/OrganSettlement/index.vue") },
    { path: "/BankAccount", name: "结算银行信息", component: () => import("../views/BankAccount/index.vue") },
    { path: "/MyInfo", name: "我的信息", component: () => import("../views/MyInfo/index.vue") },
    { path: "/ChangePassWord", name: "修改密码", component: () => import("../views/ChangePassWord/index.vue") },

    { path: "/CommonAppDown", name: "相关下载", component: () => import("../views/CommonAppDown/index.vue") },
    { path: "/SaoBei", name: "扫呗钱包", component: () => import("../views/SaoBei/index.vue") },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes: routeArray,
});

router.beforeEach((to, from, next) => {
    if (to.name != "登录页" && !sessionStorage.getItem("Token")) {
        next({ name: "登录页" });
        return;
    }
    document.title = to.name;
    next();
});
export default router;
